import React from 'react';
import Button from '../atoms/Button.jsx';

const AccountRowActions = ({ onView }) => (
  <Button variant="secondary" onClick={onView} className="px-2 py-1 text-xs">
    View
  </Button>
);

export default AccountRowActions; 